import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/ibm-plex-sans/300.css';
import '@backstage/ui/css/styles.css';
import '@internal/ui/tokens.css';
import './theme/primary-components.css';
import './theme/material-icons.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
